import { render, staticRenderFns } from "./ChangeInstance.vue?vue&type=template&id=11a70ff5"
import script from "./ChangeInstance.vue?vue&type=script&lang=js"
export * from "./ChangeInstance.vue?vue&type=script&lang=js"
import style0 from "./ChangeInstance.vue?vue&type=style&index=0&id=11a70ff5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports